import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { useCheckDevice } from '../../../hooks/UseCheckDevice';

type LeftPanelProps = {
  backgroundColor?: string;
  color?: string;
  className?: string;
  padding?: string;
  children?: ReactNode;
};

const LeftPanel: FC<LeftPanelProps> = (props) => {
  const { isMobileDevice } = useCheckDevice();

  return (
    <>
      <Wrapper data-testid='left-panel' color={props.color} backgroundColor={props.backgroundColor}>
        <Children
          isMobileDevice={isMobileDevice}
          data-testid='left-panel-container'
          padding={props.padding}
        >
          {props.children}
        </Children>
      </Wrapper>
    </>
  );
};

export default LeftPanel;

const Wrapper = styled.section.attrs<LeftPanelProps>((props) => ({
  className: `${props.className}`,
}))<LeftPanelProps>`
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  color: ${(props) => props.color ?? props.theme.palette.black};
  display: flex;
  padding: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
`;

type ContainerProps = {
  padding?: string;
  isMobileDevice: boolean;
};

const Children = styled.div.attrs<ContainerProps>({
  className: 'container-fluid',
})<ContainerProps>`
  ${(props) => props.padding && `padding: ${props.padding};`};
  width: 100%;
  margin-bottom: ${(props) => (props.isMobileDevice ? 'none' : '-7px')};
`;
